<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" epub:type="chapter" id="chapter-1" role="doc-chapter">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed"><span class="element-number-term">Chapter</span> <span class="element-number-number">One</span></h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width"><i>As I watch from afar, I know this is the one.</i></p>
<p class="subsq"><i>I allow the camera to hang by its strap as I wipe clammy hands on my black jeans. The camera returns to its position, ready to snap the essential photos.</i></p>
<p class="subsq"><i>The music blares out in the club, and no one notices as I move around to capture the necessary angles. Once complete, I relax my grip and admire the view. The object is perfection; there is only one flaw. Possession is not yet in sight…</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-001.vue?20637e3e